<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="d-flex justify-content-between align-items-center">
        <h6 @click="clearCache">设备列表<i class="fas fa-sync-alt ms-2" style="cursor: pointer;"></i></h6>
        <button
          type="button"
          class="btn btn-primary btn-sm mb-0"
          :disabled="selectedBoardIds.length === 0"
          @click="openFotaModal"
        >
          升级固件
        </button>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                选择
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                设备ID
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                隶属商户
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                状态
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                入网时间
              </th>
              <th class="text-secondary opacity-7">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="device in paginatedDevices" :key="device.board_id">
              <td class="align-middle text-center">
                <div class="form-check d-flex justify-content-center">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="device.board_id"
                    v-model="selectedBoardIds"
                  />
                </div>
              </td>
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="deviceImg"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                  alt="device-avatar"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                <h6 class="mb-0 text-sm">ID: {{ device.board_id }}</h6>
                <p class="text-xs text-secondary mb-0">{{ device.board_type_name }}</p>
                  </div>
                </div>
              </td>
              <td>
            <p class="text-xs font-weight-bold mb-0">{{ device.deliver_id ? `商户 ${device.deliver_id}` : '未知商户' }}</p>
            <p class="text-xs text-secondary mb-0">{{ device.location || '未知位置' }}</p>
              </td>
          <td class="align-middle text-center text-sm">
            <soft-badge
              :color="device.online === 1 ? 'success' : 'danger'"
              variant="gradient"
              size="sm"
            >
              {{ device.online === 1 ? '当前在线' : '当前离线' }}
            </soft-badge>
          </td>
          <!-- 入网时间 -->
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {{ formattedDate(device.date) }}
            </span>
          </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="test coin"
                  @click="openTestCoinModal(device.board_id, device.online)"
                  >测试投币</a
                >
                <span class="mx-2 text-secondary">|</span>
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="uart config"
                  @click="openUartModal(device)"
                  >串口配置</a
                >
              </td>

              <!-- Test Coin Modal -->
              <div
                v-if="isModalVisible"
                class="modal fade show"
                style="display: block; padding-right: 17px;"
                tabindex="-1"
                role="dialog"
                aria-labelledby="testCoinModalLabel"
                aria-hidden="false"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="testCoinModalLabel">请输入投币数量</h5>
                      <!-- <h5 class="modal-title" id="testModelPort">请输入端口号</h5> -->
                    </div>
                    <div class="modal-body">
                      <input
                        v-model="coinCount"
                        type="number"
                        class="form-control"
                        placeholder="请输入投币数量"
                        min="1"
                      />
                      <input
                        v-model="port"
                        type="number"
                        class="form-control"
                        placeholder="请输入端口号"
                        min="1"
                      />
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="closeModal">取消</button>
                      <button type="button" class="btn btn-primary" @click="submitTestCoin">确认</button>
                    </div>
                  </div>
                </div>
              </div>

            </tr>

          </tbody>
        </table>
      </div>
      <div
        v-if="isFotaModalVisible"
        class="modal fade show"
        style="display: block; padding-right: 17px;"
        tabindex="-1"
        role="dialog"
        aria-labelledby="fotaModalLabel"
        aria-hidden="false"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="fotaModalLabel">升级固件</h5>
            </div>
            <div class="modal-body">
              <div class="mb-3 text-sm">
                当前选择设备ID：{{ selectedBoardIdsText }}
              </div>
              <input
                v-model="fotaOssName"
                type="text"
                class="form-control"
                placeholder="请输入升级包oss_name"
              />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeFotaModal">取消</button>
              <button type="button" class="btn btn-primary" @click="openFotaConfirm">确认</button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isFotaConfirmVisible"
        class="modal fade show"
        style="display: block; padding-right: 17px;"
        tabindex="-1"
        role="dialog"
        aria-labelledby="fotaConfirmLabel"
        aria-hidden="false"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="fotaConfirmLabel">风险提示</h5>
            </div>
            <div class="modal-body">
              <div class="mb-2 text-sm">
                此操作将会下发指定的升级包到客户端，务必确认设备与升级包版本。
              </div>
              <div class="text-sm">
                设备ID：{{ selectedBoardIdsText }}
              </div>
              <div class="text-sm">
                升级包：{{ fotaOssName || '未填写' }}
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeFotaConfirm">取消</button>
              <button type="button" class="btn btn-danger" :disabled="fotaSubmitting" @click="submitFotaUpgrade">确认下发</button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isUartModalVisible"
        class="modal fade show"
        style="display: block; padding-right: 17px;"
        tabindex="-1"
        role="dialog"
        aria-labelledby="uartConfigModalLabel"
        aria-hidden="false"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="uartConfigModalLabel">串口配置</h5>
            </div>
            <div class="modal-body">
              <div class="mb-2 text-sm">
                设备ID：{{ uartBoardId || '未选择' }}
              </div>
              <div class="mb-3 text-sm text-secondary">
                当前端口：{{ currentUartConfig ? currentUartConfig.uart_port || '未上报' : '未上报' }}
              </div>
              <div class="mb-3 text-sm text-secondary">
                当前波特率：{{ currentUartConfig ? currentUartConfig.uartport_baud_rate || '未上报' : '未上报' }}
              </div>
              <div class="mb-3 text-sm text-secondary">
                上次更新时间：{{ currentUartConfig ? formattedDate(currentUartConfig.updated_date || 0) : '未上报' }}
              </div>
              <input
                v-model="uartForm.uartPort"
                type="number"
                class="form-control mb-2"
                placeholder="指定端口号（可选）"
                min="0"
              />
              <input
                v-model="uartForm.baudrate"
                type="number"
                class="form-control mb-2"
                placeholder="指定波特率"
                min="1"
              />
              <input
                v-model="uartForm.baudrateList"
                type="text"
                class="form-control"
                placeholder="批量端口波特率，如 0:115200,1:9600"
              />
              <div class="text-xs text-secondary mt-2">
                批量输入优先于单端口设置
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeUartModal">取消</button>
              <button type="button" class="btn btn-outline-primary" :disabled="uartRefreshCooling" @click="refreshUartConfig">
                {{ uartRefreshCooling ? '请稍后' : '刷新配置' }}
              </button>
              <button type="button" class="btn btn-primary" @click="submitUartConfig">保存设置</button>
            </div>
          </div>
        </div>
      </div>
      <!-- 添加分页控件 -->
      <div class="d-flex justify-content-between align-items-center px-4 py-3">
        <div class="text-sm text-gray-700">
          显示 {{ startIndex + 1 }} - {{ endIndex }} 条，共 {{ totalDevices }} 条
        </div>
        <div class="flex-shrink-0">
          <nav aria-label="Page navigation">
            <ul class="pagination pagination-sm mb-0">
              <!-- 上一页按钮 -->
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                  <i class="fas fa-chevron-left"></i>
                </a>
              </li>
              
              <!-- 页码按钮 -->
              <li v-for="page in displayedPages" 
                  :key="page" 
                  class="page-item"
                  :class="{ active: page === currentPage }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">
                  {{ page }}
                </a>
              </li>
              
              <!-- 下一页按钮 -->
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                  <i class="fas fa-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import { mapActions, mapGetters } from "vuex";
import { formatDate } from "@/utils/dateformat";

export default {
  name: "device-table",
  data() {
    return {
      deviceImg: require("../../assets/img/device.png"),  // 默认头像
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示设备数量
      displayPageCount: 5, // 每次显示的页码数量

      isModalVisible: false,
      coinCount: 1,
      selectedBoardId: null,
      selectedBoardIds: [],
      isFotaModalVisible: false,
      isFotaConfirmVisible: false,
      fotaOssName: "",
      fotaSubmitting: false,
      isUartModalVisible: false,
      uartBoardId: "",
      uartForm: {
        uartPort: "",
        baudrate: "",
        baudrateList: "",
      },
      uartRefreshCooling: false,
      uartRefreshTimer: null,
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
  },
  computed:{
    ...mapGetters('boards', ['getAllDevices', 'getUartConfigByBoardId']),
    devices(){
      return this.getAllDevices;
    },
    currentUartConfig() {
      if (!this.uartBoardId) {
        return null;
      }
      return this.getUartConfigByBoardId(this.uartBoardId);
    },
    selectedBoardIdsText() {
      if (this.selectedBoardIds.length === 0) {
        return "未选择设备";
      }
      return this.selectedBoardIds.join(", ");
    },
    // 计算总页数
    totalPages() {
      return Math.ceil(this.totalDevices / this.pageSize);
    },
    // 计算总记录数
    totalDevices() {
      return this.devices.length;
    },
    // 计算当前页的设备列表
    paginatedDevices() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.devices.slice(start, end);
    },
    // 计算起始索引
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    // 计算结束索引
    endIndex() {
      return Math.min(this.startIndex + this.pageSize, this.totalDevices);
    },
    // 计算要显示的页码
    displayedPages() {
      let start = Math.max(1, this.currentPage - Math.floor(this.displayPageCount / 2));
      let end = start + this.displayPageCount - 1;
      
      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, end - this.displayPageCount + 1);
      }
      
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    ...mapActions('boards', ['fetchDevices', 'clearLocalCache', 'fetchUartConfig', 'setUartConfig']),
    formattedDate(date) {
      return formatDate(date);
    },
    // 切换页码
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    openTestCoinModal(boardId, online) {
      console.log('clicked on device with board_id:', boardId, 'online:', online);
      if (online !== 1 ) {
        alert('设备离线，无法测试');
        return;
      }
      this.selectedBoardId = boardId;
      this.coinCount = 1;
      this.isModalVisible = true;
      this.port = 1;
    },

    closeModal() {
      this.isModalVisible = false;
    },

    submitTestCoin(){
      if (this.coinCount && this.coinCount > 0) {
        console.log('port', this.port)
        this.$store.dispatch('boards/testCoinsRequest',{
          board_id: this.selectedBoardId,
          coins: (this.coinCount*100).toString(),
          port: (this.port).toString(),
        }).then((response)=>{
          console.log('response:', response);
          if (response.code === 0) {
            alert('投币测试成功, 币数:' + this.coinCount.toString());
            this.closeModal();
          }else{
            alert(response.desc || '投币测试失败');
          }
          
        }).catch((error)=>{
          console.log('投币测试失败', error);
          alert('投币测试失败，请稍后重试');
        });
      }else{
        alert('请输入有效的投币数量');
      }
    },

    openFotaModal() {
      this.isFotaModalVisible = true;
      this.isFotaConfirmVisible = false;
      this.fotaOssName = "";
    },

    closeFotaModal() {
      this.isFotaModalVisible = false;
    },

    openFotaConfirm() {
      if (!this.fotaOssName || !this.fotaOssName.trim()) {
        alert("请输入升级包oss_name");
        return;
      }
      this.isFotaModalVisible = false;
      this.isFotaConfirmVisible = true;
    },

    closeFotaConfirm() {
      this.isFotaConfirmVisible = false;
    },

    async submitFotaUpgrade() {
      if (this.fotaSubmitting) {
        return;
      }
      if (!this.fotaOssName || !this.fotaOssName.trim()) {
        alert("请输入升级包oss_name");
        return;
      }
      const boardIds = [...this.selectedBoardIds];
      if (boardIds.length === 0) {
        alert("请先选择设备");
        return;
      }
      this.fotaSubmitting = true;
      try {
        const results = await Promise.allSettled(
          boardIds.map((boardId) =>
            this.$store.dispatch("boards/pushFotaRequest", {
              board_id: boardId,
              oss_name: this.fotaOssName.trim(),
            })
          )
        );
        const successIds = [];
        const failedItems = [];
        results.forEach((result, index) => {
          const boardId = boardIds[index];
          if (result.status === "fulfilled" && result.value && result.value.code === 0) {
            successIds.push(boardId);
          } else {
            const desc =
              result.status === "fulfilled"
                ? result.value && result.value.desc
                : result.reason && result.reason.message;
            failedItems.push({
              boardId,
              desc: desc || "下发失败",
            });
          }
        });
        if (failedItems.length === 0) {
          alert(`升级指令已下发成功\n成功设备：${successIds.join(", ")}`);
          this.selectedBoardIds = [];
        } else {
          const successText = successIds.length ? successIds.join(", ") : "无";
          const failedText = failedItems
            .map((item, index) => `${index + 1}. 设备 ${item.boardId}：${item.desc}`)
            .join("\n");
          alert(`升级指令完成\n成功设备：${successText}\n失败设备：\n${failedText}`);
          this.selectedBoardIds = failedItems.map((item) => item.boardId);
        }
      } catch (error) {
        console.log("升级指令下发失败", error);
        alert("升级指令下发失败，请稍后重试");
      } finally {
        this.fotaSubmitting = false;
        this.isFotaConfirmVisible = false;
        this.isFotaModalVisible = false;
        this.fotaOssName = "";
      }
    },

    clearCache(){
      this.clearLocalCache().then(()=>{
        //alert('本地缓存已清理');
        this.fetchDevices();
      }).catch((error)=>{
        console.log('cache clear failed:', error);
        alert('清理缓存失败，请稍后重试');
      });
    },

    openUartModal(device) {
      this.uartBoardId = device.board_id;
      this.uartForm.uartPort = "";
      this.uartForm.baudrate = "";
      this.uartForm.baudrateList = "";
      this.isUartModalVisible = true;
      this.fetchUartConfig({ board_id: device.board_id, force: false });
    },

    closeUartModal() {
      this.isUartModalVisible = false;
    },

    async refreshUartConfig() {
      if (!this.uartBoardId) {
        return;
      }
      if (this.uartRefreshCooling) {
        alert("请稍后再试");
        return;
      }
      try {
        const response = await this.fetchUartConfig({ board_id: this.uartBoardId, force: true });
        if (response && response.code === -6) {
          this.uartRefreshCooling = true;
          if (this.uartRefreshTimer) {
            clearTimeout(this.uartRefreshTimer);
          }
          this.uartRefreshTimer = setTimeout(() => {
            this.uartRefreshCooling = false;
            this.uartRefreshTimer = null;
            this.fetchUartConfig({ board_id: this.uartBoardId, force: false }).then((nextResponse) => {
              if (nextResponse && nextResponse.code === 0) {
                alert("配置已更新");
              }
            }).catch(() => {});
          }, 5000);
          alert("已下发查询，请稍后重试");
        } else if (response && response.code === 0) {
          this.uartRefreshCooling = true;
          if (this.uartRefreshTimer) {
            clearTimeout(this.uartRefreshTimer);
          }
          this.uartRefreshTimer = setTimeout(() => {
            this.uartRefreshCooling = false;
            this.uartRefreshTimer = null;
          }, 5000);
          alert("配置已更新");
        } else {
          alert(response && response.desc ? response.desc : "刷新失败");
        }
      } catch (error) {
        console.log("刷新配置失败", error);
        alert("刷新配置失败，请稍后重试");
      }
    },

    async submitUartConfig() {
      if (!this.uartBoardId) {
        alert("未选择设备");
        return;
      }
      const payload = {
        board_id: this.uartBoardId,
      };
      if (this.uartForm.baudrateList && this.uartForm.baudrateList.trim()) {
        payload.uartport_baud_rate_list = this.uartForm.baudrateList.trim();
      } else {
        if (!this.uartForm.baudrate) {
          alert("请输入波特率");
          return;
        }
        payload.uartport_baud_rate = this.uartForm.baudrate.toString();
        if (this.uartForm.uartPort !== "" && this.uartForm.uartPort !== null) {
          payload.uart_port = this.uartForm.uartPort.toString();
        }
      }
      try {
        const response = await this.setUartConfig(payload);
        if (response && response.code === 0) {
          alert("设置指令下发成功");
        } else {
          alert(response && response.desc ? response.desc : "设置失败");
        }
      } catch (error) {
        console.log("设置串口配置失败", error);
        alert("设置串口配置失败，请稍后重试");
      }
    },

  },
  mounted() {    
    this.fetchDevices().then(() => {
      this.devices.forEach((device) => {
        this.fetchUartConfig({ board_id: device.board_id, force: false });
      });
    });
  },
  beforeUnmount() {
    if (this.uartRefreshTimer) {
      clearTimeout(this.uartRefreshTimer);
    }
  }
};
</script>

<style scoped>
.pagination {
  margin: 0;
}

.page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.page-item.active .page-link {
  background-color: #344767;
  border-color: #344767;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}
</style>
